// ID del widget Elfsight Social Feed (muro misto Instagram + Facebook).
// L'associazione lo ottiene dal proprio pannello Elfsight dopo aver collegato
// l'account Instagram Business/Creator e la Pagina Facebook.
// Finché resta vuoto, la sezione mostra titolo e pulsanti "Seguici" con un
// messaggio segnaposto, senza rompere la pagina.
export const elfsightAppId = 'f20bff24-82af-4973-a859-e1e8be2743be';
